import { render } from "./ProfileLayoutClean.vue?vue&type=template&id=0a9f6b51&scoped=true"
import script from "./ProfileLayoutClean.vue?vue&type=script&lang=js"
export * from "./ProfileLayoutClean.vue?vue&type=script&lang=js"

import "./ProfileLayoutClean.vue?vue&type=style&index=0&id=0a9f6b51&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9f6b51"]])

export default __exports__